module.exports = __webpack_public_path__ + "img/close.59262717.svg";